import {
  CurrencyDollarIcon, TagIcon, CalendarIcon, UserIcon, LinkIcon, CalculatorIcon,
  CheckCircleIcon, StarIcon, PhoneIcon, EnvelopeIcon, MapPinIcon, BuildingOfficeIcon,
  BriefcaseIcon, ChartBarIcon, ClockIcon, DocumentTextIcon, FlagIcon, GlobeAltIcon,
  HashtagIcon, InformationCircleIcon, KeyIcon, LightBulbIcon, PaperClipIcon,
  PencilIcon, ShoppingCartIcon, TruckIcon, WrenchIcon,
} from "@heroicons/react/20/solid";

const ICON_MAP: Record<string, React.ComponentType<{ className?: string }>> = {
  CurrencyDollarIcon,
  TagIcon,
  CalendarIcon,
  UserIcon,
  LinkIcon,
  CalculatorIcon,
  CheckCircleIcon,
  StarIcon,
  PhoneIcon,
  EnvelopeIcon,
  MapPinIcon,
  BuildingOfficeIcon,
  BriefcaseIcon,
  ChartBarIcon,
  ClockIcon,
  DocumentTextIcon,
  FlagIcon,
  GlobeAltIcon,
  HashtagIcon,
  InformationCircleIcon,
  KeyIcon,
  LightBulbIcon,
  PaperClipIcon,
  PencilIcon,
  ShoppingCartIcon,
  TruckIcon,
  WrenchIcon,
};

export function HeroIconByName({ name, className }: { name?: string; className?: string }) {
  if (!name) return null;
  const Icon = ICON_MAP[name];
  if (!Icon) return null;
  return <Icon className={className ?? "w-4 h-4"} />;
}
